import type { ButtonProps } from '@eliadmin/core/src/components/ui/button';
import type { InputProps } from '@eliadmin/core/src/components/ui/input';
import { CiLocationOn } from 'react-icons/ci';
import { Mail as LuMail, Phone as LuPhone } from 'lucide-react';

export const CONTACT_CONFIG = {
  form: {
    submit: {
      variant: 'accent' satisfies ButtonProps['variant'],
    },
    input: {
      rounded: 'default' satisfies InputProps['type'],
    },
  },
  locationIcon: (
    <CiLocationOn stroke="hsl(var(--accent))" fill="hsl(var(--accent))" strokeWidth="1" />
  ),
  phoneIcon: <LuPhone stroke="hsl(var(--accent))" fill="white" />,
  mailIcon: <LuMail stroke="hsl(var(--accent))" fill="white" />,
} as const;
